"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginateListUserAssistantConversations = void 0;
const Apiv2Client_1 = require("../Apiv2Client");
const ListUserAssistantConversationsCommand_1 = require("../commands/ListUserAssistantConversationsCommand");
const core_1 = require("@smithy/core");
exports.paginateListUserAssistantConversations = (0, core_1.createPaginator)(Apiv2Client_1.Apiv2Client, ListUserAssistantConversationsCommand_1.ListUserAssistantConversationsCommand, "nextToken", "nextToken", "pageSize");
